import { render, staticRenderFns } from "./givingBottomBanner.vue?vue&type=template&id=311844aa&scoped=true&"
import script from "./givingBottomBanner.vue?vue&type=script&lang=js&"
export * from "./givingBottomBanner.vue?vue&type=script&lang=js&"
import style0 from "./givingBottomBanner.vue?vue&type=style&index=0&id=311844aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311844aa",
  null
  
)

export default component.exports